import { createClient } from '@supabase/supabase-js';

// These would normally be environment variables
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_KEY!;

const supabase = createClient(supabaseUrl, supabaseKey);

export async function saveEmailToSupabase(email: string, source: 'vscode' | 'cursor') {
  try {
    const { error } = await supabase
      .from('email_list')
      .insert([
        { email, source }
      ]);
      
    if (error) throw error;
    
    return { success: true };
  } catch (error) {
    console.error('Error saving email: ', error);
    return { success: false, error };
  }
} 

export function signUpWithEmail(email: string, password: string, redirectUri?: string) {
  return supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: redirectUri,
    },
  });
}

export function signInWithEmail(email: string, password: string) {
  return supabase.auth.signInWithPassword({
    email,
    password,
  });
}

export function signOut() {
  return supabase.auth.signOut();
}

export async function updateEmail(email: string) {
  try {
    const { error } = await supabase.auth.updateUser({ email });
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error updating email:', error);
    return { success: false, error };
  }
}

export async function updatePassword(password: string) {
  try {
    const { error } = await supabase.auth.updateUser({ password });
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error updating password:', error);
    return { success: false, error };
  }
}

export async function deleteAccount() {
  try {
    const { error } = await supabase.rpc('delete_user');
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error deleting account:', error);
    return { success: false, error };
  }
}

export async function getUser() {
  try {
    const { data, error } = await supabase.auth.getUser();
    if (error) throw error;
    return { user: data?.user, error: null };
  } catch (error) {
    console.error('Error retrieving user:', error);
    return { user: null, error };
  }
}

export async function resetPassword(email: string) {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error resetting password:', error);
    return { success: false, error };
  }
}